'use strict';

var paymentOptionIDs = require('../../constants').paymentOptionIDs;
var BasePayPalView = require('./base-paypal-view');

function PayPalCreditView() {
  BasePayPalView.apply(this, arguments);

  this._isPayPalCredit = true;
}

PayPalCreditView.prototype = Object.create(BasePayPalView.prototype);
PayPalCreditView.prototype.constructor = PayPalCreditView;
PayPalCreditView.ID = PayPalCreditView.prototype.ID = paymentOptionIDs.paypalCredit;

PayPalCreditView.isEnabled = function (options) {
  return BasePayPalView.isEnabled(options).then(function (enabled) {
    return enabled && Boolean(options.merchantConfiguration.paypalCredit);
  });
};
module.exports = PayPalCreditView;



//////////////////
// WEBPACK FOOTER
// ./node_modules/braintree-web-drop-in/views/payment-sheet-views/paypal-credit-view.js
// module id = MqqO
// module chunks = 3